import { render, staticRenderFns } from "./ModalSiteSettings.vue?vue&type=template&id=1999ca5f&"
import script from "./ModalSiteSettings.vue?vue&type=script&lang=js&"
export * from "./ModalSiteSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports